import { useReducer } from "react";
import { GlobalContext } from "./GlobalContext";
import { reducer } from "./Reducer";

const initialState = {
  questions: {
    business: {
      companyName: "",
      longBussiness: null,
      entityType: "",
      bussinessAnual: null,
      companyAddress: "",
      homeAddress: "",
      ownershipPercentage: null,
      secondOwnerEmail: "",
      secondOwnerPhone: "+1",
      secondOwnerFirstName: "",
      secondOwnerLastName: "",
      secondOwnerDob: "",
      secondOwnerSSN: "",
      secondOwnerHomeAddress: "",
      taxId: "",
      homeowner: false,
      percentage: 0,
      businessDescription: "",
      purchaseType: "",
      estimatedRevenue: null,
      // PD-6 Step 4 "Equipment" reveal fields — UI-only for now, no backend
      // contract exists yet for these (see Milestone 2 in the PD-6 plan).
      replacingDescription: "",
      replacingDisposition: "",
    },
    personal: {
      suffix: "",
      maritalStatus: "",
      residentialAddress: "",
      isPlanToRegisterVehicle: true,
      mailingAddress: "",
      livingYears: "",
      livingMonths: "",
      livingStatus: "",
      livingMonthlyPayment: null,
      employmentStatus: "",
      retirementIncome: null,
      retirementYears: "",
      retirementMonths: "",
      businessName: "",
      businessPhone: "+1",
      occupationTitle: "",
      employerAddress: "",
      grossMonthlyIncome: null,
      employmentYears: "",
      employmentMonths: "",
      additionalIncomeSource: "",
      additionalMonthlyIncome: null,
      isCoApplicant: false,
      coApplicantEmail: "",
      coApplicantPhone: "+1",
      coApplicantFirstName: "",
      coApplicantMiddleName: "",
      coApplicantLastName: "",
      coApplicantDob: "",
      coApplicantSsn: "",
      coApplicantCitizenship: "",
      coApplicantSuffix: "",
      coApplicantMaritalStatus: "",
      coApplicantResidentialAddress: "",
      coApplicantLivingYears: "",
      coApplicantLivingMonths: "",
      coApplicantLivingMonthlyPayment: null,
      coApplicantLivingStatus: "",
      coApplicantEmploymentStatus: "",
      coApplicantretirementIncome: null,
      coApplicantretirementYears: "",
      coApplicantretirementMonths: "",
      coApplicantAdditionalIncomeSource: "",
      coApplicantAdditionalMonthlyIncome: null,
      coApplicantBusinessName: "",
      coApplicantEmployerAddress: "",
      coApplicantGrossMonthlyIncome: null,
      coApplicantEmploymentYears: "",
      coApplicantEmploymentMonths: "",
      dealerName: "",
      dealerPhone: "+1",
      salespersonName: "",
      financingYear: "",
      financingMake: "",
      financingModel: "",
      salesprice: null,
      downPayment: null,
      isFinancingYearPrefilled: false,
      isFinancingMakePrefilled: false,
      isFinancingModelPrefilled: false,
    },
    email: "",
    phone: "+1",
    firstname: "",
    middlename: "",
    lastname: "",
    dob: "",
    ssn: "",
    citizenship: "",
    information: "",
    imageFile: null,
    imageName: "",
    fontFamily: "null",
    requestedAmount: null,
    isMarketingLink: false,
    purpleWaveIcn: "",
    // True only when the ICN came in on the link itself (?icn=) — the
    // Equipment step then doesn't ask for it.
    purpleWaveIcnFromLink: false,
    purpleWaveAuctionId: "",
    purpleWaveListingUrl: "",
    // Manually-typed Purple Wave account identifier, collected from every
    // applicant on Step 1 "You" — unrelated to purpleWaveIcn/AuctionId above,
    // which are auto-captured from a marketing listing's URL params.
    purpleWaveCustomerNumber: "",
    equipmentName: "",
    equipmentCost: null,
    equipmentUse: "Business",
    referrerUrl: "",
    referrerEquipmentDescription: "",
    referrerEquipmentCost: null,
    referrerEquipmentImageUrl: "",
    referrerEquipmentMonthlyCost: null,
    hasSalesRep: null,
    salesRepFirstName: "",
    salesRepLastName: "",
  },
  prequalifiedOffers: [],
  refreshApplications: false,
  informationSlug: "",
  applicationUUID: "",
  refreshApplicationLink: false,
  isLoggedIn: false,
  refreshProfile: false,
  signupResponse: "",
  isPersonalFlow: false,
  isSalesRepFlow: false,
  // Whether the application link belongs to the Purple Wave company (from
  // the link check) — gates every Purple Wave field in the applicant flow.
  isPurpleWaveAccount: false,

  user: {
    username: "",
    role: "",
    logo: "",
    themeColor: "",
    profilePicture: null,
    companyCategory: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNo: "",
    companyName: "",
    address: "",
    isShowOffers: false,
    isShowReports: false,
    is_allow_self_notifications: true,
  },
};
export const GlobalStateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalContext.Provider>
  );
};
